import React from "react";
import { ImageStyle, Platform } from "react-native";
import Img from "component/img";

export default function ImgIcon(props: ImageIconT & { style?: ImageStyle }) {
  const {
    size,
    width = 22,
    height = 22,
    color,
    top,
    left,
    right,
    bottom,
    mb,
    mt,
    ml,
    mr,
    style,
  } = props;
  const imgStyle: ImageStyle = {
    width: size || width,
    height: size || height,
    aspectRatio: 1,
    resizeMode: "contain",
    top,
    left,
    right,
    bottom,
    marginTop: mt,
    marginLeft: ml,
    marginRight: mr,
    marginBottom: mb,
    tintColor: color,
    ...style,
  };

  return (
    <Img
      {...(Platform.OS !== "web" && color && { tintColor: color })}
      source={props.icon}
      style={imgStyle}
    />
  );
}
